export enum InfoBoxType {
  Marketing = 'Marketing',
  Info = 'Info',
}

export enum InfoBoxIcon {
  Hero = 'Hero',
}
